import React from 'react';

export default function CustomInputLabel(props: { children: React.ReactNode }) {
  return (
    <div className="mb-2 text-brand-grey-dark text-xs font-semibold font-['Figtree'] leading-none">{props.children}</div>
  );
}
